export default function idColumn() {
    return {
        name: 'skuGroupID', label: 'ID',
        options: {
            headerAlign: 'center',
            setCellProps: () => ({ sx: { textAlign: 'center' } }),
        }
    }
}
